import { useMutation } from '@tanstack/react-query';
import { api } from '../client';
import type { LoggingLoggingInput } from '../../generated/fresh-guard-api';

export function useLoggingInsert() {
  return useMutation({
    mutationFn: async (input: { loggingInput: LoggingLoggingInput }) => {
      const res = await api.loggingApi.apiLoggingPost(input.loggingInput);
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
